<style lang="scss">
@import "consumer";
</style>

<script>
import { EventBus } from '@/event-bus'
import payByCard from '../pay-by-card/pay-by-card.vue'
import CardList from './card-list.vue'
import { mapGetters } from 'vuex'

export default {

  name: 'Consumer',

  components: {
    payByCard,
    CardList
  },

  data () {
    return {
      addcard: false,
      cardSaved: false,
      alertInfo: false,
      error: ''
    }
  },
  computed: {
    ...mapGetters(['getNativeFlowServiceId'])
  },
  created () {
    if (this.getNativeFlowServiceId(0).length === 0) {
      this.error = 'Native Flow ServiceId Missing'
    }
  },

  mounted () {
    EventBus.$on('addCard', (event) => {
      this.addcard = event
      this.cardSaved = false
    })
    EventBus.$on('cardSaved', (event) => {
      this.cardSaved = event
      this.addcard = false
      this.alertInfo = event
      setTimeout(() => {
        this.alertInfo = false
      }, 5000)
    })
  }
}
</script>

<template>
  <div
    id="consumerSection"
    class="consumerSection"
  >
    <div class="content col-xs-12 col-sm-8 col-md-6 col-lg-4 p-0">
      <div class="d-flex justify-content-between py-3 px-4 border-bottom">
        <div>
          <h2 class="p-0">
            {{ "Payment method" }}
          </h2>
        </div>
        <div
          class="align-self-center"
          @click="$emit('closeConsumer')"><span class="consumer-close-btn"/></div>
      </div>
      <div
        v-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>

      <div
        v-if="cardSaved || !addcard"
        class="py-3 px-4">
        <card-list :alert-info="alertInfo" />
      </div>
      <div
        v-if="addcard"
        class="py-3 px-4">
        <pay-by-card :show-enroll="true"/>
      </div>
    </div>
  </div>
</template>
